import React, { useState } from 'react';
import HeaderBar from '../../../common/HeaderBar';
import SideBar from '../../../common/SideBar';
import TestPreview from './TestPreview';
import CreateQuizModal from './CreateQuizModal-PG2'; // Naya component import
import './PrepSelection.scss';
import { generateCatTest } from '../../../../Redux/Teacher_Panel/cat_paper/cat.action';
import ToastMessage from '../../../../utils/toasts/toastMessage';
import { useDispatch } from 'react-redux';
import { Loader } from 'lucide-react';

const PrepSelection = () => {
   const dispatch = useDispatch();
     const [loading, setLoading] = useState(false);
    const [toastState, setToastState] = useState({ show: false, message: "", type: "" });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [generatedTests, setGeneratedTests] = useState([]);

  const academicTargets = [
    { id: 'cat', name: 'CAT Preparation', description: 'Master of Business Administration', icon: "📊", bgClass: "cat-bg" },
    { id: 'jee', name: 'JEE Main & Advanced', description: 'Engineering Entrance Exams', icon: "🧪", bgClass: "jee-bg" },
    { id: 'upsc', name: 'UPSC CSE', description: 'Civil Services Examination', icon: "🏛️", bgClass: "upsc-bg" }
  ];

const handleGenerate = async (finalData) => {
  setLoading(true);

  try {
    if (!finalData?.sections?.length) {
      throw new Error("No sections selected");
    }

    if (!finalData.date) {
      throw new Error("Date is required");
    }

    // Build sections array
    const sections = finalData.sections.map((section) => ({
      section: section,
      mcq_count: finalData.composition?.[section]?.MCQ || 0,
      tita_count: finalData.composition?.[section]?.TITA || 0,
    }));

    // Convert date + time into ISO format
    const start_time = new Date(
      `${finalData.date} ${finalData.hour}:${finalData.minute} ${finalData.period}`
    ).toISOString();

    const payload = {
      sections,
      start_time,
      duration_minutes: Number(finalData.duration),
    };

    const result = await dispatch(generateCatTest(payload));

    if (!result.success) {
      setToastState({
        show: true,
        message: result.message || "Something went wrong! Try again.",
        type: "error",
      });
    } else {
      setToastState({
        show: true,
        message: "paper created successfully.",
        type: "success",
      });
    }

    setIsModalOpen(false);
    setShowPreview(true);
  } catch (error) {
    console.error(error);

    setToastState({
      show: true,
      message: error.message || "Unexpected error occurred!",
      type: "error",
    });
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      {!showPreview ? (
        <main className="ff2 main-page no-scroll">
          <HeaderBar />
          <div className="inner-page-content">
            <SideBar />
            <section className="prep-viewport-fixed">
              <div className="prep-container">
                <header className="prep-header">
                  <h1 className="main-title">Select Academic Target</h1>
                  <p className="sub-title">Choose a specialization to manage learning content and assessments.</p>
                </header>

                <div className="selection-grid">
                  {academicTargets.map((target) => (
                    <div key={target.id} className="selection-card" onClick={() => target.id === 'cat' && setIsModalOpen(true)}>
                      <div className={`icon-wrapper ${target.bgClass}`}>
                        <span className="emoji-icon">{target.icon}</span>
                      </div>
                      <div className="text-container">
                        <h3>{target.name}</h3>
                        <p>{target.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </section>
          </div>

          {isModalOpen && (
            <CreateQuizModal 
              onClose={() => setIsModalOpen(false)} 
              onGenerate={handleGenerate} 
            />
          )}
        </main>
      ) : (
        <TestPreview 
          testData={generatedTests} 
          onFinalize={() => { alert("Finalized!"); setShowPreview(false); }} 
          onCancel={() => setShowPreview(false)} 
        />
      )}
            <Loader show={loading} />

           <ToastMessage
          show={toastState.show}
          onClose={() => setToastState({ show: false, message: "", type: "" })}
          message={toastState.message}
          type={toastState.type}
        />
    </>
  );
};

export default PrepSelection;